import { ApplicationMemberStatus } from "@domain/application/application";
import { CurrencyCode } from "@domain/currency/currency";
import { Category } from "@domain/lms/category/category";
import { Profile } from "@domain/user/profile";
import { CountryCode } from "./countryCode";

export interface CurrentProfile extends Omit<Profile, "followedByMeSince" | "followingMeSince"> {
	email: string;
	gender?: UserGender;
	birthDate?: Date;
	language?: Language;
	countryCode?: CountryCode;
	categories: Category[];
	type: "USER";
	primaryName: string;
	secondaryName?: string;
	contentCountList?: contentCountListData[];
	applicationId?: string;
	statusApplication?: ApplicationMemberStatus;
	currency?: CurrencyCode;
	monetizationTermsConsented?: boolean;
	phoneNumber?: string;
	phoneNumberAuth?: string;
	chatToken?: {
		token: string;
		expiryDate: string | null;
	};
}

export type UserGender = "MALE" | "FEMALE";

export const allLanguages = ["FRENCH", "ENGLISH"] as const;
export type Language = (typeof allLanguages)[number];

export type AdminRole = "ADMIN" | "SYS_ADMIN";
export interface contentCountListData {
	key: string;
	value: string;
}
